var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.getGlobalLoader)?_c('div',{staticClass:"global-loader"},[_c('va-progress-circle',{attrs:{"indeterminate":""}})],1):_vm._e(),_c('notifications'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }